<template>
  <a-modal title="水表用户信息" :visible="showTubeView" width="80%" destroyOnClose :getContainer="getPopupContainer"
    @ok="closeTubeView" @cancel="closeTubeView" style="position: absolute; left: 18rem; z-index: 999; top: 3rem">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="用户编码">
              <a-input v-model="query.userNo" placeholder="请输入用户编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="水表编号">
              <a-input v-model="query.appearanceNo" placeholder="请输入水表编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="用户名称">
              <a-input v-model="query.userNikeName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="手机号">
              <a-input v-model="query.phone" placeholder="请输入手机号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :data-source="dataList" :columns="columns" :loading="dataListLoading" :pagination="pagination"
      @change="pageChange">
      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ moment(text).format("YYYY-MM-DD") }}</span>
    </a-table>
  </a-modal>
</template>
<script>
import moment from 'moment'
export default {
  data () {
    return {
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName'
        },
        {
          title: '分类编码',
          dataIndex: 'classNo'
        },
        {
          title: '水表编号',
          dataIndex: 'appearanceNo'
        },
        {
          title: '用户名称',
          dataIndex: 'userNikeName'
        },
        {
          title: '用户编码',
          dataIndex: 'userNo'
        },
        {
          title: '用户地址',
          dataIndex: 'address'
        },
        {
          title: '手机号',
          dataIndex: 'phone'
        },
        {
          title: '安装时间',
          dataIndex: 'installDate'
        },
        {
          title: '口径',
          dataIndex: 'caliber'
        },
        {
          title: '品牌',
          dataIndex: 'brand'
        },
        {
          title: '类型',
          dataIndex: 'type'
        },
        {
          title: '状态',
          dataIndex: 'status'
        },
        {
          title: '用户用水类型',
          dataIndex: 'waterBigStatus',
          scopedSlots: { customRender: 'waterBigStatus' }
        }
      ],
      // queryUrl: '/pipe-network/meter_reading_user_water/page',
      queryUrl: '/pipe-network/gis_class_user_water_meters/page',
      dataList: [],
      dataListLoading: false,
      query: {
        userNo: '',
        appearanceNo: '',
        userNikeName: '',
        phone: ''
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      classNo: '',
      showTubeView: false
    }
  },
  methods: {
    moment,
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getDataList()
    },
    searchQuery () {
      this.pagination.current = 1
      this.getDataList()
    },
    resetQuery () {
      this.query = {
        userNo: '',
        appearanceNo: '',
        userNikeName: '',
        phone: ''
      }
      this.pagination.current = 1
      this.getDataList()
    },
    edit (classNo) {
      this.pagination.current = 1
      this.query = {
        userNo: '',
        appearanceNo: '',
        userNikeName: '',
        phone: ''
      }
      this.showTubeView = true
      if (classNo) {
        this.classNo = classNo
        this.getDataList()
      }
    },
    // 跳转到对应阀门
    jumpFather (record) {
      this.closeTubeView()
      this.$emit('jumpFather', record)
    },
    // 获取数据
    getDataList () {
      this.dataListLoading = true
      const params = {
        classNo: this.classNo,
        ...this.query
      }
      params.page = this.pagination.current
      params.limit = this.pagination.pageSize
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closeTubeView () {
      this.showTubeView = false
    },
    getPopupContainer () {
      return document.fullscreenElement || document.body
    }
  }
}
</script>

<style lang="less" scoped></style>
